import { NAV_PATHS } from '@modules/common/constants';
import { AnalysisUseCase } from 'generated/graphql';
import { UUID } from 'v2/core/entities/uuid';
import { getSavedSlug } from 'v2/core/services/savedSlug/utils';
import pathJoin from 'v2/core/utils/path';

interface GetAnalysisRouteParams {
  name: string;
  token: UUID;
  useCase: AnalysisUseCase;
  isReportingRoute?: boolean;
}

export const getAnalysisRoute = ({
  name,
  token,
  useCase,
  isReportingRoute = false,
}: GetAnalysisRouteParams): string => {
  if (useCase === AnalysisUseCase.Collection) {
    return `/${NAV_PATHS.COLLECTION}/${token}`;
  }

  const slug = getSavedSlug({
    name,
    token,
  });

  const path =
    useCase === AnalysisUseCase.Feed ? NAV_PATHS.FEED : NAV_PATHS.QUANTIFY;

  return `${pathJoin(isReportingRoute ? NAV_PATHS.REPORT : '', path, slug)}`;
};

interface GetAnalysisLinkParams {
  name: string;
  token: UUID;
  tenantSlug?: string;
  useCase: AnalysisUseCase;
}

export const getAnalysisLink = ({
  name,
  token,
  tenantSlug,
  useCase,
}: GetAnalysisLinkParams): string => {
  const route = getAnalysisRoute({
    name,
    token,
    useCase,
  });
  return pathJoin(window.location.origin, tenantSlug ?? '', route);
};
